import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
  Grid,
} from '@mui/material';
import { JFormikDialogProps } from './jformik.types';
import { Formik, FormikHelpers } from 'formik';
import { JFields } from './JFormik';
import { useBreakpointQuery } from '../../../utils';
import { Loading } from '../../Loading';

export const JFormikDialog = ({
  open = true,
  title,
  button,
  maxWidth = 'md',
  data,
  close,
  mutation,
  useJFormik,
}: JFormikDialogProps) => {
  const [mutate, mutateResult] = mutation;
  const {
    loading,
    jformikProps: { validationSchema, initialValues, form },
  } = useJFormik();
  const smDown = useBreakpointQuery('sm-down');
  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick') {
      close(event, reason);
    }
  };

  React.useEffect(() => {
    if (mutateResult.fulfilledTimeStamp) {
      mutateResult.reset();
      close('none', 'formSubmitted');
    }
  }, [mutateResult, close]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={maxWidth}
      scroll={'paper'}
      onClose={onClose}
      open={open}
      disableEscapeKeyDown={true}
    >
      {loading ? (
        <div className="h-400 flex flex-col items-center justify-center">
          <Loading text={''} />
        </div>
      ) : (
        <Formik
          initialValues={
            initialValues && typeof initialValues === 'function'
              ? initialValues(data)
              : {}
          }
          onSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
            mutate(values, formikHelpers)
          }
          validationSchema={validationSchema}
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <DialogTitle className="bg-gray-100">
                <div>
                  <Typography variant="h6" className="">
                    {title}
                  </Typography>
                </div>
              </DialogTitle>

              <DialogContent className="py-12">
                <Grid container spacing={smDown ? 2 : 3}>
                  <JFields items={form} />
                </Grid>
              </DialogContent>

              <DialogActions className="flex justify-start px-6 py-4 bg-gray-100">
                <Button
                  type="submit"
                  color="secondary"
                  variant="contained"
                  className="text-white"
                >
                  {button}
                  {mutateResult.isLoading && (
                    <CircularProgress
                      color="inherit"
                      size={16}
                      className="ml-4"
                    />
                  )}
                </Button>

                <Button onClick={() => onClose(null, 'anyway')} color="primary">
                  Cancel
                </Button>
              </DialogActions>
            </form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
